/*import React, { useState, useEffect } from 'react';
import { Camera, Send, CheckCircle, Loader2, Globe, Award, Instagram, Youtube, Trophy, Music2, Info, User, Copy, Check, Share2, Layers, Facebook, Lock, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase';
import { collection, addDoc, serverTimestamp, getDocs, query, orderBy } from "firebase/firestore";

const Nominate = () => {
  // --- TOGGLE THIS TO OPEN/CLOSE THE FORM ---
  const isClosed = true; 

  // DATA STATE
  const [groups, setGroups] = useState([]); 
  const [allAwards, setAllAwards] = useState([]); 
  const [filteredAwards, setFilteredAwards] = useState([]); 

  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', county: 'Taita Taveta',
    parentCategory: '', 
    category: '', 
    reason: '', achievements: '',
    instagram: '', tiktok: '', youtube: '', facebook: '',
    slug: '', referral: '', consent: false
  });
  
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [copied, setCopied] = useState(false);

  // 1. FETCH HIERARCHICAL DATA
  useEffect(() => {
    if (isClosed) return; // Don't fetch if closed
    const fetchData = async () => {
      try {
        const groupSnap = await getDocs(query(collection(db, "main_categories"), orderBy("name", "asc")));
        const awardSnap = await getDocs(query(collection(db, "sub_categories"), orderBy("name", "asc")));
        setGroups(groupSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setAllAwards(awardSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) { console.error("Fetch error:", err); }
    };
    fetchData();
  }, [isClosed]);

  // (Helper functions handleGroupChange, slug gen, etc. remain the same...)
  const handleGroupChange = (e) => {
    const groupId = e.target.value;
    const groupName = groups.find(g => g.id === groupId)?.name || "";
    setFormData({ ...formData, parentCategory: groupName, category: '' });
    const filtered = allAwards.filter(award => award.parentGroupId === groupId);
    setFilteredAwards(filtered);
  };

  useEffect(() => {
    const slug = (formData.name || "").toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    setFormData(prev => ({ ...prev, slug }));
  }, [formData.name]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isClosed) return;
    // ... (Your existing handleSubmit logic)
  };

  // --- RENDER CLOSED SCREEN ---
  if (isClosed) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 py-20 font-sans relative overflow-hidden">
        {/* Background Glow *//*
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full pointer-events-none" />
        
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }} 
          animate={{ opacity: 1, scale: 1 }} 
          className="max-w-2xl w-full text-center relative z-10"
        >
          <div className="mb-10 inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/20">
            <Lock size={40} className="text-[#D4AF37]" />
          </div>

          <h1 className="text-5xl md:text-7xl font-black uppercase italic tracking-tighter leading-none mb-6">
            NOMINATIONS <span className="text-[#D4AF37]">CLOSED</span>
          </h1>
          
          <div className="h-[1px] w-20 bg-[#D4AF37] mx-auto mb-8" />

          <p className="text-slate-400 text-sm md:text-base uppercase font-bold tracking-[0.3em] leading-relaxed mb-12 italic px-4">
            The participation window for the <br/> 
            <span className="text-white font-black italic">MZINYI TAITA TAVETA AWARDS 2026</span> <br/> 
            is now officially closed.
          </p>

          <div className="bg-zinc-900/50 border border-white/5 p-8 rounded-[2rem] backdrop-blur-sm mb-12">
            <p className="text-xs text-white/40 uppercase tracking-widest font-black mb-4 italic">What's Next?</p>
            <h3 className="text-xl font-black uppercase italic text-white mb-2">Voting is Now Live</h3>
            <p className="text-[10px] text-[#D4AF37] font-bold uppercase tracking-widest">Support your favorite local legends today</p>
          </div>

          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <Link to="/categories" className="flex-1">
              <button className="w-full bg-[#D4AF37] text-black py-6 rounded-2xl font-black uppercase tracking-[0.3em] text-xs flex items-center justify-center gap-3 hover:bg-white transition-all shadow-2xl">
                 Go to Voting Portal <ArrowRight size={16}/>
              </button>
            </Link>
            <Link to="/" className="flex-1">
              <button className="w-full border border-white/10 text-white/40 py-6 rounded-2xl font-black uppercase tracking-[0.3em] text-xs hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all">
                 Return Home
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    );
  }

  // (The rest of your original Return block for the open form goes here...)
  return (
    <div className="min-h-screen bg-[#000000] text-white pt-24 pb-20 px-6 font-sans">
      
    </div>
  );
};

export default Nominate; */












/*
import React, { useState, useEffect } from 'react';
import { Camera, Send, CheckCircle, Loader2, Globe, Award, Instagram, Youtube, Trophy, Music2, Info, User, Copy, Check, Share2, Layers, Facebook } from 'lucide-react';
import { motion } from 'framer-motion';
import { db } from '../serices/firebase';
import { collection, addDoc, serverTimestamp, getDocs, query, orderBy } from "firebase/firestore";

const Nominate = () => {
  // DATA STATE
  const [groups, setGroups] = useState([]); 
  const [allAwards, setAllAwards] = useState([]); 
  const [filteredAwards, setFilteredAwards] = useState([]); 

  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', county: 'Taita Taveta',
    parentCategory: '', 
    category: '', 
    reason: '', achievements: '',
    instagram: '', tiktok: '', youtube: '', facebook: '',
    slug: '', referral: '', consent: false
  });
  
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [copied, setCopied] = useState(false);

  // 1. FETCH HIERARCHICAL DATA (Groups & Specific Awards)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const groupSnap = await getDocs(query(collection(db, "main_categories"), orderBy("name", "asc")));
        const awardSnap = await getDocs(query(collection(db, "sub_categories"), orderBy("name", "asc")));
        
        setGroups(groupSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setAllAwards(awardSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };
    fetchData();
  }, []);

  // 2. HANDLE CATEGORY CASCADING
  const handleGroupChange = (e) => {
    const groupId = e.target.value;
    const groupName = groups.find(g => g.id === groupId)?.name || "";
    
    setFormData({ ...formData, parentCategory: groupName, category: '' });
    const filtered = allAwards.filter(award => award.parentGroupId === groupId);
    setFilteredAwards(filtered);
  };

  // 3. SLUG GENERATION
  useEffect(() => {
    const slug = (formData.name || "").toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    setFormData(prev => ({ ...prev, slug }));
  }, [formData.name]);

  const fullLink = `${window.location.origin}/vote/${formData.slug}`;

  // 4. SUBMIT LOGIC


  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!formData.name.trim()) return alert("Please enter a name.");
  if (!formData.category) return alert("Please select a specific award.");
  if (!image) return alert("Please upload a portrait photo.");
  if (!formData.consent) return alert("Please agree to the terms.");

  setLoading(true);

  // --- NEW: PHONE NUMBER SANITIZATION ---
  // This converts 07... or 01... to 254...
  const sanitizePhone = (phone) => {
    let cleaned = phone.replace(/\D/g, ''); // Remove non-digits
    if (cleaned.startsWith('0')) {
      return '254' + cleaned.substring(1);
    }
    // If they already typed 254..., leave it. If they started with 7... add 254
    if (cleaned.startsWith('7') || cleaned.startsWith('1')) {
      return '254' + cleaned;
    }
    return cleaned;
  };

  const finalSlug = formData.name.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

  try {
    // Cloudinary Upload
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    const res = await fetch(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`, { 
      method: "POST", 
      body: data 
    });
    const fileData = await res.json();
    
    if (!res.ok) throw new Error(fileData.error?.message || "Image upload failed");

    const nominationData = {
      name: formData.name.trim(),
      phone: sanitizePhone(formData.phone), // <--- APPLIED SANITIZATION HERE
      email: formData.email,
      county: formData.county,
      parentCategory: formData.parentCategory,
      category: formData.category,
      reason: formData.reason,
      achievements: formData.achievements || "",
      socials: { 
          instagram: formData.instagram || "", 
          tiktok: formData.tiktok || "", 
          youtube: formData.youtube || "",
          facebook: formData.facebook || ""
      },
      imageUrl: fileData.secure_url,
      slug: finalSlug,
      status: "pending",
      voteCount: 0,
      createdAt: serverTimestamp()
    };

    await addDoc(collection(db, "nominations"), nominationData);
    
    setFormData(prev => ({ ...prev, slug: finalSlug }));
    setSuccess(true);
    window.scrollTo(0, 0);
  } catch (err) {
    alert("Submission Error: " + err.message);
  } finally { 
    setLoading(false); 
  }
};

  const inputStyle = "w-full bg-zinc-900/50 border border-white/20 rounded-xl px-4 py-4 outline-none focus:border-[#D4AF37] transition-all text-white font-medium placeholder:text-white/20 mb-6";
  const labelStyle = "text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.3em] mb-3 flex items-center gap-2 italic";

  // --- RENDER SUCCESS SCREEN ---
  if (success) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-center">
        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="max-w-md w-full">
          <CheckCircle className="text-[#D4AF37] w-20 h-20 mx-auto mb-6" />
          <h1 className="text-4xl font-black mb-2 uppercase text-white tracking-tighter italic leading-none">Application Sent!</h1>
          <div className="flex flex-col gap-2 mb-8 mt-4">
            <span className="text-white/40 text-[9px] font-bold uppercase tracking-[0.4em]">{formData.parentCategory}</span>
            <span className="bg-[#D4AF37] text-black px-4 py-1 text-[10px] font-black uppercase tracking-widest rounded-full italic mx-auto">{formData.category}</span>
          </div>
          <p className="text-slate-400 mb-10 text-xs uppercase font-bold leading-relaxed italic">Your profile is under review by the committee.</p>
          <div className="bg-zinc-900 border border-white/10 p-2 rounded-xl flex items-center mb-6">
            <input readOnly value={fullLink.replace('https://', '')} className="bg-transparent border-none text-[#D4AF37] text-[10px] px-4 w-full outline-none font-bold lowercase" />
            <button onClick={() => { navigator.clipboard.writeText(fullLink); setCopied(true); setTimeout(() => setCopied(false), 2000); }} className="bg-white/5 hover:bg-[#D4AF37] hover:text-black p-3 rounded-lg transition-all">{copied ? <Check size={18} /> : <Copy size={18} />}</button>
          </div>
          <button onClick={() => window.location.href = '/'} className="w-full bg-[#D4AF37] text-black py-5 font-black uppercase tracking-[0.3em] rounded-xl hover:bg-white transition-all shadow-xl">Return Home</button>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#000000] text-white pt-24 pb-20 px-6 font-sans">
      <div className="max-w-4xl mx-auto">
        <header className="mb-16 text-center">
            <h1 className="text-5xl md:text-8xl font-black uppercase italic tracking-tighter leading-none mb-4">NOMINATE <span className="text-[#D4AF37]">TALENT</span></h1>
            <p className="text-slate-500 font-bold tracking-[0.5em] uppercase text-[10px]">Official 2026 Participation Form</p>
        </header>

        <form onSubmit={handleSubmit} className="space-y-12 bg-zinc-900/20 p-8 md:p-12 rounded-[2.5rem] border border-white/5 shadow-2xl backdrop-blur-sm">
          {/* 01. PERSONAL INFO *//*
          <section>
            <h3 className={labelStyle}><User size={14}/> 01. Personal Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
              <input type="text" placeholder="Full Name / Stage Name" required className={inputStyle} onChange={e => setFormData({...formData, name: e.target.value})} />
              <input type="tel" placeholder="Phone Number" required className={inputStyle} onChange={e => setFormData({...formData, phone: e.target.value})} />
              <input type="email" placeholder="Email Address" required className={inputStyle} onChange={e => setFormData({...formData, email: e.target.value})} />
              <input type="text" placeholder="Location (e.g. Voi)" required className={inputStyle} value={formData.county} onChange={e => setFormData({...formData, county: e.target.value})} />
            </div>
          </section>

          {/* 02. CATEGORY HIERARCHY *//*
          <section>
            <h3 className={labelStyle}><Layers size={14}/> 02. Choose Sector & Award</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <select required className={inputStyle} onChange={handleGroupChange}>
                   <option value="">-- Choose Sector --</option>
                   {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
                </select>

                <select 
                    required 
                    disabled={!formData.parentCategory}
                    className={inputStyle} 
                    onChange={e => setFormData({...formData, category: e.target.value})}
                >
                   <option value="">-- Choose Specific Award --</option>
                   {filteredAwards.map(a => <option key={a.id} value={a.name}>{a.name}</option>)}
                </select>
            </div>
          </section>

          {/* 03. DESCRIPTION *//*
          <section>
            <h3 className={labelStyle}><Info size={14}/> 03. About the Talent</h3>
            <textarea placeholder="Why should you be nominated?" required className={inputStyle} rows="3" onChange={e => setFormData({...formData, reason: e.target.value})} />
            <textarea placeholder="Key highlights or achievements" className={inputStyle} rows="2" onChange={e => setFormData({...formData, achievements: e.target.value})} />
          </section>

          {/* 04. SOCIALS *//*
          <section>
            <h3 className={labelStyle}><Globe size={14}/> 04. Social Media Links</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 italic">
              <div className="relative"><Instagram className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="Instagram" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, instagram: e.target.value})} /></div>
              <div className="relative"><Music2 className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="TikTok" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, tiktok: e.target.value})} /></div>
              <div className="relative"><Youtube className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="YouTube" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, youtube: e.target.value})} /></div>
              <div className="relative"><Facebook className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="Facebook URL" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, facebook: e.target.value})} /></div>
            </div>
          </section>

          {/* 05. PHOTO *//*
          <section>
            <h3 className={labelStyle}><Camera size={14}/> 05. Profile Portrait</h3>
            <div className="relative w-full h-72 border-2 border-dashed border-white/20 bg-black rounded-3xl flex flex-col items-center justify-center overflow-hidden hover:border-[#D4AF37] transition-all group">
               {image ? <img src={URL.createObjectURL(image)} alt="Preview" className="w-full h-full object-cover" /> : <div className="text-center"><Camera size={32} className="text-white/10 mx-auto mb-2 group-hover:text-[#D4AF37] transition-colors"/><p className="text-white/20 font-bold uppercase text-[9px] tracking-widest italic">Upload Portrait</p></div>}
               <input type="file" required onChange={e => setImage(e.target.files[0])} className="absolute inset-0 opacity-0 cursor-pointer" />
            </div>
          </section>

          <div className="flex items-start gap-4 p-6 bg-zinc-900/50 rounded-2xl border border-white/5 italic">
             <input type="checkbox" required className="w-6 h-6 mt-1 accent-[#D4AF37]" onChange={e => setFormData({...formData, consent: e.target.checked})} />
             <label className="text-[10px] text-slate-400 font-bold leading-relaxed uppercase tracking-wider">I confirm the info is correct and I agree to join MZINYI 2026.</label>
          </div>

          <button disabled={loading} className="w-full bg-[#D4AF37] text-black py-7 font-black uppercase tracking-[0.4em] hover:bg-white transition-all flex justify-center items-center gap-4 shadow-2xl disabled:opacity-50">
            {loading ? <Loader2 className="animate-spin text-black"/> : <><Send size={18}/> Submit Application</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Nominate;*/





import React, { useState, useEffect } from 'react';
//import { Camera, Send, CheckCircle, Loader2, Globe, Award, Instagram, Youtube, Trophy, Music2, Info, User, Copy, Check, Share2, Layers, Facebook } from 'lucide-react';
import {
  Camera,
  Send,
  CheckCircle,
  Loader2,
  Info,
  User,
  Copy,
  Check,
  Layers
} from 'lucide-react';
import { motion } from 'framer-motion';
import { db } from '../serices/firebase';
import { collection, addDoc, serverTimestamp, getDocs, query, orderBy } from "firebase/firestore";
//import { getEventPhase } from '../utils/eventDates';

const Nominate = () => {
  // DATA STATE
  const [groups, setGroups] = useState([]); 
  const [allAwards, setAllAwards] = useState([]); 
  const [filteredAwards, setFilteredAwards] = useState([]); 

  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', county: 'Taita Taveta',
    parentCategory: '', 
    category: '', 
    reason: '', achievements: '',
   // instagram: '', tiktok: '', youtube: '', facebook: '',
    slug: '', referral: '', consent: false
  });
  
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [copied, setCopied] = useState(false);

  //const phase = getEventPhase();

  // 1. FETCH HIERARCHICAL DATA (Groups & Specific Awards)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const groupSnap = await getDocs(query(collection(db, "main_categories"), orderBy("name", "asc")));
        const awardSnap = await getDocs(query(collection(db, "sub_categories"), orderBy("name", "asc")));
        
        setGroups(groupSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setAllAwards(awardSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };
    fetchData();
  }, []);

  // 2. HANDLE CATEGORY CASCADING
  const handleGroupChange = (e) => {
    const groupId = e.target.value;
    const groupName = groups.find(g => g.id === groupId)?.name || "";
    
    setFormData({ ...formData, parentCategory: groupName, category: '' });
    const filtered = allAwards.filter(award => award.parentGroupId === groupId);
    setFilteredAwards(filtered);
  };

  // 3. SLUG GENERATION
  useEffect(() => {
    const slug = (formData.name || "").toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    setFormData(prev => ({ ...prev, slug }));
  }, [formData.name]);

  const fullLink = `${window.location.origin}/vote/${formData.slug}`;

  // 4. HELPER: convert the selected image file to base64 for our upload function
  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // strip the "data:...;base64," prefix
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  // 5. SUBMIT LOGIC
  const handleSubmit = async (e) => {
  e.preventDefault();
  //if (phase !== 'nominating') return alert("Nominations are closed for this cycle.");
  if (!formData.name.trim()) return alert("Please enter a name.");
  if (!formData.category) return alert("Please select a specific award.");
  if (!image) return alert("Please upload a portrait photo.");
  if (!formData.consent) return alert("Please agree to the terms.");

  setLoading(true);

  // --- PHONE NUMBER SANITIZATION ---
  // This converts 07... or 01... to 254...
  const sanitizePhone = (phone) => {
    let cleaned = phone.replace(/\D/g, ''); // Remove non-digits
    if (cleaned.startsWith('0')) {
      return '254' + cleaned.substring(1);
    }
    // If they already typed 254..., leave it. If they started with 7... add 254
    if (cleaned.startsWith('7') || cleaned.startsWith('1')) {
      return '254' + cleaned;
    }
    return cleaned;
  };

  const finalSlug = formData.name.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

    try {
  // --- Bunny.net Upload ---
  const fileBase64 = await fileToBase64(image);

  const res = await fetch("/.netlify/functions/uploadImage", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fileBase64,
      fileName: image.name,
      contentType: image.type,
    }),
  });

  // Read response safely
  const responseText = await res.text();

  let fileData = {};

  try {
    fileData = responseText ? JSON.parse(responseText) : {};
  } catch (parseError) {
    console.error(
      "Invalid response from uploadImage:",
      responseText
    );

    throw new Error(
      `Upload server returned an invalid response (${res.status}).`
    );
  }

  // Check upload status
  if (!res.ok) {
    console.error("Image upload failed:", {
      status: res.status,
      response: fileData,
    });

    throw new Error(
      fileData.error ||
      fileData.details ||
      `Image upload failed (${res.status})`
    );
  }

  // Check URL
  if (!fileData.imageUrl) {
    throw new Error(
      "Image upload succeeded, but no image URL was returned."
    );
  }

    const nominationData = {
      name: formData.name.trim(),
      phone: sanitizePhone(formData.phone),
      email: formData.email,
      county: formData.county,
      parentCategory: formData.parentCategory,
      category: formData.category,
      reason: formData.reason,
      achievements: formData.achievements || "",
      /*socials: { 
          instagram: formData.instagram || "", 
          tiktok: formData.tiktok || "", 
          youtube: formData.youtube || "",
          facebook: formData.facebook || ""
      },*/
      imageUrl: fileData.imageUrl,
      slug: finalSlug,
      status: "pending",
      voteCount: 0,
      createdAt: serverTimestamp()
    };

    await addDoc(collection(db, "nominations"), nominationData);
    
    setFormData(prev => ({ ...prev, slug: finalSlug }));
    setSuccess(true);
    window.scrollTo(0, 0);
  } catch (err) {
    alert("Submission Error: " + err.message);
  } finally { 
    setLoading(false); 
  }
};

  const inputStyle = "w-full bg-zinc-900/50 border border-white/20 rounded-xl px-4 py-4 outline-none focus:border-[#D4AF37] transition-all text-white font-medium placeholder:text-white/20 mb-6";
  const labelStyle = "text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.3em] mb-3 flex items-center gap-2 italic";

  // --- RENDER SUCCESS SCREEN ---
  if (success) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-center">
        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="max-w-md w-full">
          <CheckCircle className="text-[#D4AF37] w-20 h-20 mx-auto mb-6" />
          <h1 className="text-4xl font-black mb-2 uppercase text-white tracking-tighter italic leading-none">Nomination Sent!</h1>
          <div className="flex flex-col gap-2 mb-8 mt-4">
            <span className="text-white/40 text-[9px] font-bold uppercase tracking-[0.4em]">{formData.parentCategory}</span>
            <span className="bg-[#D4AF37] text-black px-4 py-1 text-[10px] font-black uppercase tracking-widest rounded-full italic mx-auto">{formData.category}</span>
          </div>
          <p className="text-slate-400 mb-10 text-xs uppercase font-bold leading-relaxed italic">Your profile is under review by the committee.</p>
          <div className="bg-zinc-900 border border-white/10 p-2 rounded-xl flex items-center mb-6">
            <input readOnly value={fullLink.replace('https://', '')} className="bg-transparent border-none text-[#D4AF37] text-[10px] px-4 w-full outline-none font-bold lowercase" />
            <button onClick={() => { navigator.clipboard.writeText(fullLink); setCopied(true); setTimeout(() => setCopied(false), 2000); }} className="bg-white/5 hover:bg-[#D4AF37] hover:text-black p-3 rounded-lg transition-all">{copied ? <Check size={18} /> : <Copy size={18} />}</button>
          </div>
          <button onClick={() => window.location.href = '/'} className="w-full bg-[#D4AF37] text-black py-5 font-black uppercase tracking-[0.3em] rounded-xl hover:bg-white transition-all shadow-xl">Return Home</button>
        </motion.div>
      </div>
    );
  }

 /* if (phase !== 'nominating') {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6 text-center">
      <div className="max-w-md w-full">
        <h1 className="...">Nominations Closed</h1>
        <p className="...">The nomination window for MZINYI 2026 has ended...</p>
        <button onClick={() => window.location.href = '/categories'} className="...">
          Go to Voting
        </button>
      </div>
    </div>
  );
}*/

  return (
    <div className="min-h-screen bg-[#000000] text-white pt-24 pb-20 px-6 font-sans">
      <div className="max-w-4xl mx-auto">
        <header className="mb-16 text-center">
            <h1 className="text-5xl md:text-8xl font-black uppercase italic tracking-tighter leading-none mb-4">NOMINATE <span className="text-[#D4AF37]">TALENT</span></h1>
            <p className="text-slate-500 font-bold tracking-[0.5em] uppercase text-[10px]">Official 2026 Participation Form</p>
        </header>

        <form onSubmit={handleSubmit} className="space-y-12 bg-zinc-900/20 p-8 md:p-12 rounded-[2.5rem] border border-white/5 shadow-2xl backdrop-blur-sm">
          {/* 01. PERSONAL INFO */}
          <section>
            <h3 className={labelStyle}><User size={14}/> 01. Personal Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
              <input type="text" placeholder="Full Name / Stage Name" required className={inputStyle} onChange={e => setFormData({...formData, name: e.target.value})} />
              <input type="tel" placeholder="Phone Number" required className={inputStyle} onChange={e => setFormData({...formData, phone: e.target.value})} />
              <input type="email" placeholder="Email Address" required className={inputStyle} onChange={e => setFormData({...formData, email: e.target.value})} />
              <input type="text" placeholder="Location (e.g. Voi)" required className={inputStyle} value={formData.county} onChange={e => setFormData({...formData, county: e.target.value})} />
            </div>
          </section>

          {/* 02. CATEGORY HIERARCHY */}
          <section>
            <h3 className={labelStyle}><Layers size={14}/> 02. Choose Sector & Award</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <select required className={inputStyle} onChange={handleGroupChange}>
                   <option value="">-- Choose Sector --</option>
                   {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
                </select>

                <select 
                    required 
                    disabled={!formData.parentCategory}
                    className={inputStyle} 
                    onChange={e => setFormData({...formData, category: e.target.value})}
                >
                   <option value="">-- Choose Specific Award --</option>
                   {filteredAwards.map(a => <option key={a.id} value={a.name}>{a.name}</option>)}
                </select>
            </div>
          </section>

          {/* 03. DESCRIPTION */}
          <section>
            <h3 className={labelStyle}><Info size={14}/> 03. About the Talent</h3>
            <textarea placeholder="Why should you be nominated?" required className={inputStyle} rows="3" onChange={e => setFormData({...formData, reason: e.target.value})} />
            <textarea placeholder="Key highlights or achievements" className={inputStyle} rows="2" onChange={e => setFormData({...formData, achievements: e.target.value})} />
          </section>

          {/* 04. SOCIALS */}
          {/*<section>
            <h3 className={labelStyle}><Globe size={14}/> 04. Social Media Links (OPTIONAL)</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 italic">
              <div className="relative"><Instagram className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="Instagram" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, instagram: e.target.value})} /></div>
              <div className="relative"><Music2 className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="TikTok" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, tiktok: e.target.value})} /></div>
              <div className="relative"><Youtube className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="YouTube" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, youtube: e.target.value})} /></div>
              <div className="relative"><Facebook className="absolute left-4 top-4 text-[#D4AF37]" size={18} /><input type="url" placeholder="Facebook URL" className={`${inputStyle} pl-12 text-xs`} onChange={e => setFormData({...formData, facebook: e.target.value})} /></div>
            </div>
          </section>*/}

          {/* 05. PHOTO */}
          <section>
            <h3 className={labelStyle}><Camera size={14}/> 05. Profile Portrait</h3>
            <div className="relative w-full h-72 border-2 border-dashed border-white/20 bg-black rounded-3xl flex flex-col items-center justify-center overflow-hidden hover:border-[#D4AF37] transition-all group">
               {image ? <img src={URL.createObjectURL(image)} alt="Preview" className="w-full h-full object-cover" /> : <div className="text-center"><Camera size={32} className="text-white/10 mx-auto mb-2 group-hover:text-[#D4AF37] transition-colors"/><p className="text-white/20 font-bold uppercase text-[9px] tracking-widest italic">Upload Portrait</p></div>}
               <input type="file" required onChange={e => setImage(e.target.files[0])} className="absolute inset-0 opacity-0 cursor-pointer" />
            </div>
          </section>

          <div className="flex items-start gap-4 p-6 bg-zinc-900/50 rounded-2xl border border-white/5 italic">
             <input type="checkbox" required className="w-6 h-6 mt-1 accent-[#D4AF37]" onChange={e => setFormData({...formData, consent: e.target.checked})} />
             <label className="text-[10px] text-slate-400 font-bold leading-relaxed uppercase tracking-wider">I confirm the info is correct and I agree to join MZINYI 2026.</label>
          </div>

          <button disabled={loading} className="w-full bg-[#D4AF37] text-black py-7 font-black uppercase tracking-[0.4em] hover:bg-white transition-all flex justify-center items-center gap-4 shadow-2xl disabled:opacity-50">
            {loading ? <Loader2 className="animate-spin text-black"/> : <><Send size={18}/> Submit Nomination</>}
          </button>
        </form>
      </div>
    </div>
  );
 };

 export default Nominate;
